export const validatePrecision = (value) => {
    if(/^\d+(\.\d{1,2})?$/g.test(value)) {
        return undefined;
    }
    return 'Error precision';
}